// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"46":"vendor.jspdf","512":"vendor.canvg","954":"vendor.dompurify"}[chunkId] || chunkId) + "." + {"46":"d9a7f67f","421":"dba8a48d","512":"9e7e44a0","954":"34a7f993"}[chunkId] + ".chunk.js";
};